import React from "react";
import { connect } from "react-redux";
import DynamicMainScreen from "../../../components/dynamicscreens/DynamicMainScreen";
import { YearColumns } from "../../../tableColumns/table-columns";
import { yearJson } from "../../../DynamicFormsJson/MastersJSON/year";
import { getYear } from "../../../Slice/year.slice";
import { noInternetMsg, statusmsg } from "../../../config/messageconstant";
import { showLoador, showNotification } from "../../Landing/Landing.slice";
import { apiPost } from "../../../utils/api_service";

class YearTable extends React.Component {
  constructor(props) {
    super(props);
  }

  componentDidMount() {
    if (navigator.onLine) {
      localStorage.removeItem("yearForRegionWiseTarget");
    } else {
      this.props.showNotification({ msg: noInternetMsg, severity: "error" });
    }
  }

  onChangeStatus = async (rowData) => {
    const { showLoador, showNotification, getYear } = this.props;

    let status = rowData.isActive == 1 ? 0 : 1;

    showLoador({ loador: true });
    await apiPost({
      url: yearJson.isActiveURL + "?id=" + rowData.id + "&status=" + status,
    }).then(async ({ data, success }) => {
      if (data.data.statusCode == 500) {
        showNotification({
          msg: data.data.message,
          severity: "error",
        });
      } else {
        showNotification({
          msg: statusmsg,
        });
        await getYear();
      }
    });
    showLoador({ loador: false });
  }

  render() {
    const { yearList, getYear } = this.props;
    return (
      <>
        <DynamicMainScreen
          formPath={yearJson.formPath}
          screenTitle={yearJson.screenTitle}
          fieldMeta={yearJson.fieldMeta}
          showPdfDownload={false}
          showExcelDownload={true}
          changeExcelURL={yearJson.excelUrl}
          showExtension={false}
          filterDataExcel={true}
          pdfFileName={yearJson.pdfFileName}
          excelFileName={yearJson.excelFileName}
          showAddButton={yearJson.showAddButton}
          tableColumnsToFilter={yearJson.tableColumnsToFilter}
          tableColumns={YearColumns}
          tableData={yearList?.year}
          getTableData={getYear}
          apiBaseURL={yearJson.apiBaseURL}
          baseIdColumn={yearJson.baseIdColumn}
          isNote={true}
          isNoteValue={"Add Financial Year"}
          showDeleteIcon={true}
          showViewButtonInTable={true}
          formPathView={yearJson.formPathView}
          isActiveURLFalse={true}
          isActiveURLFalseMethod={this.onChangeStatus}
        />
      </>
    );
  }
}
const mapStateToProps = (state) => ({
  yearList: state.year,
});
const mapDispatchToProps = {
  getYear,
  showLoador,
  showNotification,
};
export default connect(mapStateToProps, mapDispatchToProps)(YearTable);
